import { useLocalization } from '@magicdoorinc/ui';
import { createMemo, Show } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import {
  CreateCompanyBankAccountContent,
  CreateCompanyBankAccountFooter,
} from '~/components/company-type-confirm/CreateCompanyBankAccountContent';
import { CompanyTypeConfirmStep, useCompanyTypeConfirm } from '~/contexts/local';
import ConfirmationContent, { ConfirmationFooter } from './ConfirmationContent';
import SelectCompanyBankAccountsContent, { SelectCompanyBankAccountsFooter } from './SelectCompanyBankAccountsContent';
import SelectCompanyTypeContent, { SelectCompanyTypeFooter } from './SelectCompanyTypeContent';
import SelectDefaultCompanyBankAccountContent, { SelectDefaultCompanyBankAccountFooter } from './SelectDefaultCompanyBankAccountContent';
import type { Component } from 'solid-js';

const CompanyTypeConfirmModal: Component = () => {
  const { t } = useLocalization();
  const { visible, step } = useCompanyTypeConfirm();

  const modalConfig = createMemo<{ title?: string; Content: Component; Footer: Component }>(() => {
    const configMap: Record<CompanyTypeConfirmStep, { title?: string; Content: Component; Footer: Component }> = {
      [CompanyTypeConfirmStep.SelectCompanyType]: {
        Content: SelectCompanyTypeContent,
        Footer: SelectCompanyTypeFooter,
      },
      [CompanyTypeConfirmStep.SelectCompanyBankAccounts]: {
        title: t('Company operating account'),
        Content: SelectCompanyBankAccountsContent,
        Footer: SelectCompanyBankAccountsFooter,
      },
      [CompanyTypeConfirmStep.CreateCompanyBankAccount]: {
        title: t('Company operating account'),
        Content: CreateCompanyBankAccountContent,
        Footer: CreateCompanyBankAccountFooter,
      },
      [CompanyTypeConfirmStep.SelectDefaultCompanyBankAccount]: {
        title: t('Company operating account'),
        Content: SelectDefaultCompanyBankAccountContent,
        Footer: SelectDefaultCompanyBankAccountFooter,
      },
      [CompanyTypeConfirmStep.Confirmation]: {
        Content: ConfirmationContent,
        Footer: ConfirmationFooter,
      },
    };

    const defaultConfig: { title?: string; Content: Component; Footer: Component } = {
      Content: (() => null) as Component,
      Footer: (() => null) as Component,
    };
    const currentStep = step();

    if (!currentStep) {
      return defaultConfig;
    }

    return configMap[currentStep] || defaultConfig;
  });

  return (
    <Show when={visible()}>
      <div class="fixed inset-0 z-100 flex items-center justify-center bg-black/60 p-4">
        <div class="flex w-full max-w-screen-sm flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
          <Show when={modalConfig().title}>
            <div class="flex items-center justify-between border-b px-6 py-4">
              <h2 class="text-lg font-medium text-text-02">{modalConfig().title}</h2>
            </div>
          </Show>
          <Dynamic component={modalConfig().Content} />
          <Dynamic component={modalConfig().Footer} />
        </div>
      </div>
    </Show>
  );
};

export default CompanyTypeConfirmModal;
